import * as React from 'react';
export const soundOnSvg = React.forwardRef(function soundOnSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M12.408 4.03a.75.75 0 0 1 1.014-.31A4.844 4.844 0 0 1 16 8.012a4.844 4.844 0 0 1-2.578 4.293.75.75 0 0 1-.703-1.325 3.353 3.353 0 0 0 0-5.935.75.75 0 0 1-.311-1.014Zm-8.465.232L7.773.47A1.562 1.562 0 0 1 8.875 0C9.714 0 10.5.693 10.5 1.655V14.36c0 .962-.786 1.64-1.624 1.64-.38 0-.771-.129-1.104-.455l-.003-.002-3.816-3.78h-.261C1.638 11.762 0 10.07 0 8.012c0-2.059 1.638-3.75 3.692-3.75h.25ZM5 5.326 8.823 1.54c.028-.027.045-.03.053-.032a.088.088 0 0 1 .049.008.12.12 0 0 1 .05.043.158.158 0 0 1 .025.096V14.36c0 .05-.013.079-.024.095a.12.12 0 0 1-.051.043.088.088 0 0 1-.05.009c-.007-.002-.024-.006-.052-.032v-.001L5 10.688V5.326ZM1.5 8.012c0-1.19.89-2.142 2-2.241v4.483c-1.11-.1-2-1.052-2-2.242Z',
    }),
  );
});
soundOnSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var soundOn = {
  category: 'icon',
  colorable: true,
  name: 'soundOn',
  svg: soundOnSvg,
};
